import React from 'react'

const Conversation = () => {
    return (
        <div className="indicator flex items-center mt-2 mb-4 gap-2">
            <div className='w-12 rounded-full '>
            <span className="indicator-item indicator-bottom indicator-start  scale-x-50 scale-y-50 indicator-item-xs badge badge-success" ></span>
                <img
                    src='https://cdn0.iconfinder.com/data/icons/communication-line-10/24/account_profile_user_contact_person_avatar_placeholder-512.png'
                    alt='user avatar'
                    
                />
            </div>
            <div >
                <h4 className="text-md font-semibold">John Doe</h4>
                <p className="text-slate-200 text-sm">Hey there! How are you?</p>
            </div>
        </div>
    )
}

export default Conversation